import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=b9ba5108&scoped=true&"
import script from "./AudioPlayer.vue?vue&type=script&lang=tsx&"
export * from "./AudioPlayer.vue?vue&type=script&lang=tsx&"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=b9ba5108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ba5108",
  null
  
)

export default component.exports